import { TABLE, TD, TH } from "@/components/tool-kit/styles";
import type { WordConverterStrings } from "@/components/tools/bibtex-to-word-source-manager";
import { Badge } from "@/components/tools/reference-tools/badge";
import type { WordSource } from "@/lib/tool-kit/reference-tools/word-sources";

/*
 * The sources a Word file will hold: tag, Word's source type, where each came from and
 * anything worth checking. Every word comes from the widget's strings.
 */

function titleOf(source: WordSource): string {
  return source.fields.find(([name]) => name === "Title")?.[1] ?? "";
}

export function WordSourceList({
  sources,
  strings,
}: {
  sources: readonly WordSource[];
  strings: WordConverterStrings;
}) {
  return (
    <div className="space-y-2">
      <p className="font-medium text-foreground text-sm">
        {strings.listHeading}
      </p>
      <div className="overflow-x-auto rounded-lg border border-border bg-card">
        <table className={TABLE}>
          <thead>
            <tr>
              <th className={TH} scope="col">
                {strings.tag}
              </th>
              <th className={TH} scope="col">
                {strings.wordType}
              </th>
              <th className={TH} scope="col">
                {strings.from}
              </th>
              <th className={TH} scope="col">
                {strings.title}
              </th>
              <th className={TH} scope="col">
                {strings.notesHeading}
              </th>
            </tr>
          </thead>
          <tbody>
            {sources.map((source) => (
              <tr key={source.tag}>
                <td className={`${TD} font-mono text-xs`}>{source.tag}</td>
                <td className={TD}>{strings.types[source.type]}</td>
                <td className={`${TD} font-mono text-xs`}>
                  {source.origin.format === "bibtex"
                    ? `@${source.origin.type}`
                    : source.origin.type}
                </td>
                <td className={`${TD} min-w-48`}>{titleOf(source)}</td>
                <td className={TD}>
                  <div className="flex flex-wrap gap-1">
                    {source.notes.map((note) => (
                      <Badge key={note} tone="warn">
                        {strings.notes[note]}
                      </Badge>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
